type SportLike = {
  id?: string | number;
  popularity_rank?: number | string | null;
  teams_count?: number | null;
  athletes_count?: number | null;
  spotlight_score?: number | null;
  spotlight_label?: string | null;
  spotlight_reason?: string | null;
};

export const hasSportSpotlightSignal = (sport: SportLike) =>
  Boolean(
    sport.popularity_rank ||
      Number(sport.teams_count ?? 0) > 0 ||
      Number(sport.athletes_count ?? 0) > 0 ||
      Number(sport.spotlight_score ?? 0) > 0,
  );

export const getSportSpotlightItems = (sports: SportLike[], limit = 3) =>
  sports
    .filter(hasSportSpotlightSignal)
    .sort((sportA, sportB) => {
      const scoreDelta = Number(sportB.spotlight_score ?? 0) - Number(sportA.spotlight_score ?? 0);

      if (scoreDelta !== 0) {
        return scoreDelta;
      }

      const rankA = Number(sportA.popularity_rank ?? Number.POSITIVE_INFINITY);
      const rankB = Number(sportB.popularity_rank ?? Number.POSITIVE_INFINITY);

      if (rankA !== rankB) {
        return rankA - rankB;
      }

      const athleteDelta = Number(sportB.athletes_count ?? 0) - Number(sportA.athletes_count ?? 0);

      if (athleteDelta !== 0) {
        return athleteDelta;
      }

      return Number(sportB.teams_count ?? 0) - Number(sportA.teams_count ?? 0);
    })
    .slice(0, limit);
